'use strict';

angular.module('shiftTraderApp')
    .factory('Organizations', function (ServerUrls, $http, Departments, Session, $q) {
      var path = ServerUrls.current.railsApi + 'organizations/';
      var nodePath = ServerUrls.current.nodeApi.slice(0, -3) + 'v2/organizations/';

      var Organization = function(initData) {
        var org = {};
        angular.extend(org, initData);

        org.created_at = moment.utc(org.created_at).tz(Session.getTimezone());

        if (!_.isUndefined(org.departments)) {
          if (org.departments.length > 0) {
            org.departments = _.map(org.departments, function (dept) {
              return Departments.initWithData(dept);
            });
          }

          if (_.findIndex(org.departments, {id: null}) < 0) {
            org.departments.push({
              id: null,
              name: 'No Department'
            });
          }
        } else {
          org.departments = [];
        }

        org.formattedPhoneNumber = function() {
          var temp = org.organization_config.phone_number.replace(/[^0-9]/g,'');
          return temp.replace(/[1]?(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        };

        org.$isAllowedToCreate = function() {
          return _.isNull(org.active_until) ||  moment.utc().isBefore(org.active_until);
        };

        org.$update = function(data) {
          var that = this;
          return $http.put(path + this.id, data)
            .then(function(response) {
              angular.extend(that, response.data);  //copy in new properties from server
              return response.data;
            }, function(response) {
              return $q.reject(response);
            });
        };
        return org;
      };

      var Organizations = {};
      Organizations.getById = function (id, setSession) {
        return $http.get(nodePath + id)
          .then(function (response) {
            if (!_.isUndefined(setSession)) {
              Session.setCurrentOrgId(response.data.id);
            }
            return new Organization(response.data);
          }, function(response) {
            return $q.reject(response);
          });
      };

      Organizations.getCurrentOrg = function() {
        var theOrgId = Session.getCurrentOrgId();
        if (_.isUndefined(theOrgId) || _.isNull(theOrgId)) {
          theOrgId = 'primary';
        }

        return Organizations.getById(theOrgId, true);
      };

      return Organizations;
    });
